import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowSettingsPopupContent.SectionNetSuiteAmaxUrl', {
    title: 'ApprovalMax URL to NetSuite',
    subtitle: 'When should we update an “ApprovalMax URL“ custom field in NetSuite?',
    afterApproval: 'After final approval / rejection',
    afterSync: 'After first requests sync to ApprovalMax',
});
